import type { RootState } from '@/stores/store';

export const selectSelectedAgent = (state: RootState) => state.agent.selectedAgent;
